// extracted by mini-css-extract-plugin
export default {"toggleWithMessage":"kHwEKHGa6V"};